import type { ReactNode } from 'react';
import { TabBar } from './TabBar.js';

interface ShellProps {
  children: ReactNode;
  /** Some pages (Home, ActiveTrip) need a full-bleed map; hide the safe footer padding for those. */
  fullBleed?: boolean;
  hideTabBar?: boolean;
}

export function Shell({ children, fullBleed, hideTabBar }: ShellProps) {
  return (
    <div className="mx-auto flex h-full min-h-svh max-w-mobile flex-col bg-white">
      <main className={'relative flex-1 ' + (fullBleed ? '' : 'pb-20')}>{children}</main>
      {hideTabBar ? null : <TabBar />}
    </div>
  );
}
